export default {
    name: "Home",
    components: {},
    data() {
        return { 
            name: '',
            calendar: false,
            email: '',
            company: '',
            phone: '',
            message: '',
            labelForm: 'Send',
            speakers: [
                {
                    cat: "",
                    time: "",
                    img: "barnes.png",
                    label: "Deputy Director",
                    desc: "Bhavika Mithani works on Ofgem’s Vulnerability and Consumer Policy, currently focusing on non-domestic customers through Ofgem’s Microbusiness Strategic Review. Bhavika has worked in Ofgem for over 7 years, with previous experience in vulnerable domestic consumer policy as well as in the delivery and compliance of Ofgem’s Environmental Programmes.",
                    name: "Bhavika Mithani",
                    position: "Vulnerability and Consumer Policy, Ofgem",
                },
                {
                    cat: "",
                    time: "",
                    img: "jacqui.png",
                    label: "CEO",
                    desc: "Jacqui Hall is MD of CNG Ltd, a leading UK energy supplier which is celebrating its 25th year of not only supplying their customers with energy, but giving them power too! Jacqui is a real CNG veteran, having started out as an Office Manager, she progressed through the ranks and has helped drive CNG to become one of the industry’s most stand-out businesses. Her accolades over the years comprise a multitude of awards not only as an employer, but for her personal contribution and approach to business in the region.",
                    name: "Jacqui Hall",
                    position: "CNG",
                },
                {
                    cat: "",
                    time: "",
                    img: "david.png",
                    label: "CEO",
                    desc: "David is a Cambridge graduate with an impressive career working as a finance professional in the services industry, having held CFO and Finance Director positions in both the I&C and SME sectors before joining OnlineDIRECT. As CEO at OnlineDIRECT, he champions collaboration and customer centric strategy, ensuring services and propositions are tailored to ensure profitability for Brokers and suppliers in the ever changing UK energy market.",
                    name: "David Coombs",
                    position: "OnlineDIRECT",
                },
                {
                    cat: "",
                    time: "",
                    img: "simon.png",
                    label: "Principal Ecologist",
                    desc: "Dr Simon Pickering has been a professional ecologist for over 30 years with a particular expertise in renewable energy,  climate change  and sustainable development. Simon has seen the impact of climate change across the world and now works for Ecotricity, Britain’s Greenest Energy Company. In his spare time he has been Chair of the Environment Committee on Stroud District Council, which not only became the first carbon neutral council in Europe in 2015 but is leading on becoming a carbon neutral district by 2030",
                    name: "Dr. Simon Pickering",
                    position: "Ecotricity",
                },
            ],
            timeline: [
                {
                    cat: "Registration",
                    time: "08.30 to 09.00",
                    img: "subscribe.svg",
                    label: "Registration & refreshments",
                    desc: "",
                    name: "",
                    position: "",
                },
                {
                    cat: "Opening",
                    time: "09.30 to 09.35",
                    img: "nicky.png",
                    label: "Welcome & Opening",
                    desc: "",
                    name: "Nicky Wilson-Everett",
                    position: "Head of Sales, Online DIRECT",
                },
                {
                    cat: "Keynote",
                    time: "09.35 to 10.00",
                    img: "david.png",
                    label: "The View from The TPI & End Customer",
                    desc: "What do end customers actually want from brokers and TPI’s?  What are the current views and trends from brokers?  These questions will be answered as David walks us through industry research and insights.",
                    name: "David Coombs",
                    position: "CEO, Online DIRECT",
                },
                {
                    cat: "Keynote",
                    time: "10.00 to 10.30",
                    img: "jacqui.png",
                    label: "Adopting a customer centric approach",
                    desc: "Jacqui will take us through her views and beliefs on why adopting a customer centric approach is critical to survival and growth for TPI’s and suppliers",
                    name: "Jacqui Hall",
                    position: "CEO CNG",
                },
                {
                    cat: "Keynote",
                    time: "10.30 to 11.00",
                    img: "simon.png",
                    label: "Our obligation to the future",
                    desc: "In this session Simon explores how the B2B energy sector has a critical role to play in helping to build a brighter and more sustainable future for the generations that follow",
                    name: "Dr. Simon Pickering",
                    position: "Principal Ecologist, Ecotricity",
                },
                {
                    cat: "Interval",
                    time: "11.00 to 11.30",
                    img: "break.svg",
                    label: "Break, refreshments and networking",
                    desc: "",
                    name: "",
                    position: "",
                },
                {
                    cat: "Keynote",
                    time: "11.30 to 12.00",
                    img: "barnes.png",
                    label: "The View from The Regulator",
                    desc: "Regulation isn’t something to be feared but embraced.  Bhavika Mithani shares the Ofgems unique perspective on how the B2B energy sector is adapting to changing dynamics.",
                    name: "Bhavika Mithani",
                    position: "Vulnerability and Consumer Policy, Ofgem",
                },
                {
                    cat: "Keynote",
                    time: "12.00 to 12.45",
                    img: "gascomp.png",
                    label: "The View from the Supplier",
                    desc: "15 minute rapid fire presentations from 3 of the industry’s leading energy suppliers ",
                    name: "CNG, British Gas & Gazprom",
                    position: "",
                },
                {
                    cat: "Interval",
                    time: "12.45 to 13.55",
                    img: "lunch.svg",
                    label: "Lunch & Networking",
                    desc: "",
                    name: "",
                    position: "",
                },
                {
                    cat: "Track 1",
                    time: "14.00 to 14.30",
                    img: "---",
                    label: "Financial Planning",
                    desc: "",
                    name: "Business planning & development",
                    position: "",
                },
                {
                    cat: "Track 1",
                    time: "14.45 to 15.15",
                    img: "---",
                    label: "A Guide to Best Practice",
                    desc: "",
                    name: "Business planning & development",
                    position: "",
                },
                {
                    cat: "Track 1",
                    time: "15.30 to 16.00",
                    img: "---",
                    label: "How to grow your sales team",
                    desc: "",
                    name: "Business planning & development",
                    position: "",
                },
                {
                    cat: "Track 2",
                    time: "14.00 to 14.30",
                    img: "---",
                    label: "Siteworks & New Connections",
                    desc: "",
                    name: "INNOVATIONS & DIVERSIFICATION",
                    position: "",
                },
                {
                    cat: "Track 2",
                    time: "14.45 to 15.15",
                    img: "---",
                    label: "Understanding Energy Analytics",
                    desc: "",
                    name: "INNOVATIONS & DIVERSIFICATION",
                    position: "",
                },
                {
                    cat: "Track 2",
                    time: "15.30 to 16.00",
                    img: "---",
                    label: "Introduction to Water Tendering",
                    desc: "",
                    name: "INNOVATIONS & DIVERSIFICATION",
                    position: "",
                },
                {
                    cat: "Closing",
                    time: "16.30 to 17.00",
                    img: "david.png",
                    label: "Closing thoughts and Q & A",
                    desc: "",
                    name: "David Coombs",
                    position: "CEO, Online DIRECT",
                },
                {
                    cat: "Interval",
                    time: "17.00 - 18.00",
                    img: "drinks.svg",
                    label: "Drinks & Networking",
                    desc: "",
                    name: "",
                    position: "",
                },
                {
                    cat: "Thank You",
                    time: "18.00",
                    img: "hand.svg",
                    label: "Close of the event",
                    desc: "",
                    name: "",
                    position: "",
                },
            ]
        }
    },
    methods: {
        classSet(c){
            let x = '';
            if(c == "Track 1"){
                x += 't1 '
            }
            if(c == "Track 2"){
                x += 't2 '
            }
            return '' + x + '';
        },
        mobile(platform){
            if(!platform){
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true;
                }else{
                    return false;
                }
            }else{
                if(platform == 'iPhone'){
                    if (/iPhone/i.test(navigator.userAgent)) {
                        return true;
                    } else {
                        return false;
                    }
                }
                if (platform == 'iPad'){
                    if (/iPad/i.test(navigator.userAgent)) {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        submitForm(){
            this.labelForm = 'Please Wait...';
            if (this.email.indexOf("@") != -1){
                document.querySelector('.contact form').submit();
                setTimeout(()=>{
                    this.labelForm = "Message Sent!"
                    setTimeout(() => {
                        this.labelForm = "Send";
                        this.name = '';
                        this.email = '';
                        this.company = '';
                        this.phone = '';
                        this.message = '';
                    }, 2000);
                }, 2000);
            }else{
                this.labelForm = 'Please type a valid e-mail address';
                setTimeout(()=>{
                    this.labelForm = 'Send';
                }, 3000);
            }
        }
    },
    created() {
    },
    mounted() { 
        setTimeout(()=>{
            let AOS = window.AOS;
            AOS.init({
                // Global settings:
                disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
                startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
                initClassName: 'aos-init', // class applied after initialization
                animatedClassName: 'aos-animate', // class applied on animation
                useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
                disableMutationObserver: false, // disables automatic mutations' detections (advanced)
                debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
                throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)


                // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
                offset: 120, // offset (in px) from the original trigger point
                delay: 0, // values from 0 to 3000, with step 50ms
                duration: 400, // values from 0 to 3000, with step 50ms
                easing: 'ease', // default easing for AOS animations
                once: false, // whether animation should happen only once - while scrolling down
                mirror: false, // whether elements should animate out while scrolling past them
                anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

            });
        });
    },
};
